import { createContext, useContext, useState, useCallback, useEffect } from "react";

const STRINGS = {
  nl: {
    "app.name": "Zoetwaren Kompas",
    "login.title": "Inloggen",
    "login.subtitle": "Log in om Zoetwaren Kompas te gebruiken.",
    "login.email": "E-mailadres",
    "login.password": "Wachtwoord",
    "login.submit": "Inloggen",
    "login.forgot": "Wachtwoord vergeten?",
    "login.google": "Inloggen met Google",
    "login.google.note": "Google-inloggen is uitsluitend mogelijk voor bestaande gebruikers. Neem contact op met de beheerder voor een account.",
    "login.or": "of",
    "login.noaccount": "Nog geen account? Neem contact op met je beheerder.",
    "forgot.title": "Wachtwoord vergeten",
    "forgot.subtitle": "Vul je e-mailadres in; je ontvangt een herstellink als het account bestaat.",
    "forgot.submit": "Verstuur herstellink",
    "forgot.back": "Terug naar inloggen",
    "reset.title": "Nieuw wachtwoord instellen",
    "reset.subtitle": "Kies een nieuw wachtwoord voor je account (minimaal 8 tekens).",
    "reset.new": "Nieuw wachtwoord",
    "reset.repeat": "Herhaal nieuw wachtwoord",
    "reset.submit": "Wachtwoord instellen",
    "reset.checking": "Herstellink controleren…",
    "reset.invalid": "Deze herstellink is ongeldig, verlopen of al gebruikt.",
    "reset.invalid.hint": "Vraag via het inlogscherm een nieuwe herstellink aan met \u2018Wachtwoord vergeten?\u2019.",
    "reset.success": "Je wachtwoord is opnieuw ingesteld.",
    "reset.success.hint": "Je kunt nu inloggen met je nieuwe wachtwoord.",
    "reset.tologin": "Naar inloggen",
    "common.cancel": "Annuleren",
    "common.save": "Opslaan",
    "common.loading": "Bezig…",
    "common.language": "Taal",
    "nav.qa": "Vraag & antwoord",
    "nav.salaris": "Salarischeck",
    "nav.functie": "Functiecheck",
    "nav.mijn": "Mijn omgeving",
    "nav.tilcheck": "Tilcheck",
    "nav.handboek": "Functiehandboek",    "nav.or": "OR-analyse",
    "nav.caowijzer": "CAO-wijzer",
    "nav.contract": "Contractcheck",
    "nav.bronnen": "Bronnen",
    "nav.dashboard": "Dashboard",
    "nav.gebruikers": "Gebruikersbeheer",
    "nav.experiment": "Functiecheck-experiment",
    "nav.logout": "Uitloggen",
    "avg.title": "Nog één stap",
    "avg.confirm": "Akkoord en doorgaan",
    "avg.logout": "Uitloggen",
    "users.title": "Gebruikersbeheer",
    "users.subtitle": "Beheer accounts, rollen en toegang. Alleen zichtbaar voor superbeheerders.",
    "users.new": "Nieuwe gebruiker",
    "users.email": "E-mailadres",
    "users.name": "Naam",
    "users.role": "Rol",
    "users.status": "Status",
    "users.lastlogin": "Laatste login",
    "users.actions": "Acties",
    "users.active": "Actief",
    "users.inactive": "Geblokkeerd",
    "users.block": "Blokkeren",
    "users.unblock": "Deblokkeren",
    "users.resetpw": "Wachtwoord resetten",
    "users.temppw": "Tijdelijk wachtwoord",
    "users.create": "Aanmaken",
    "users.created": "Gebruiker aangemaakt.",
    "login.error": "Onjuiste inloggegevens.",
  },
  en: {
    "app.name": "Zoetwaren Kompas",
    "login.title": "Sign in",
    "login.subtitle": "Sign in to use Zoetwaren Kompas.",
    "login.email": "Email address",
    "login.password": "Password",
    "login.submit": "Sign in",
    "login.forgot": "Forgot password?",
    "login.google": "Sign in with Google",
    "login.google.note": "Google sign-in is only available for existing users. Contact your administrator for an account.",
    "login.or": "or",
    "login.noaccount": "No account yet? Please contact your administrator.",
    "forgot.title": "Forgot password",
    "forgot.subtitle": "Enter your email; you'll receive a reset link if the account exists.",
    "forgot.submit": "Send reset link",
    "forgot.back": "Back to sign in",
    "reset.title": "Set a new password",
    "reset.subtitle": "Choose a new password for your account (minimum 8 characters).",
    "reset.new": "New password",
    "reset.repeat": "Repeat new password",
    "reset.submit": "Set password",
    "reset.checking": "Checking reset link…",
    "reset.invalid": "This reset link is invalid, expired or already used.",
    "reset.invalid.hint": "Request a new reset link via \u2018Forgot password?\u2019 on the sign-in screen.",
    "reset.success": "Your password has been reset.",
    "reset.success.hint": "You can now sign in with your new password.",
    "reset.tologin": "Go to sign in",
    "common.cancel": "Cancel",
    "common.save": "Save",
    "common.loading": "Loading…",
    "common.language": "Language",
    "nav.qa": "Questions & answers",
    "nav.salaris": "Salary check",
    "nav.functie": "Job check",
    "nav.mijn": "My space",
    "nav.tilcheck": "Lifting check",
    "nav.handboek": "Job handbook",    "nav.or": "Works council analysis",
    "nav.caowijzer": "CLA guide",
    "nav.contract": "Contract check",
    "nav.bronnen": "Sources",
    "nav.dashboard": "Dashboard",
    "nav.gebruikers": "User management",
    "nav.experiment": "Job check experiment",
    "nav.logout": "Sign out",
    "avg.title": "One more step",
    "avg.confirm": "Agree and continue",
    "avg.logout": "Sign out",
    "users.title": "User management",
    "users.subtitle": "Manage accounts, roles and access. Only visible to superadmins.",
    "users.new": "New user",
    "users.email": "Email address",
    "users.name": "Name",
    "users.role": "Role",
    "users.status": "Status",
    "users.lastlogin": "Last login",
    "users.actions": "Actions",
    "users.active": "Active",
    "users.inactive": "Blocked",
    "users.block": "Block",
    "users.unblock": "Unblock",
    "users.resetpw": "Reset password",
    "users.temppw": "Temporary password",
    "users.create": "Create",
    "users.created": "User created.",
    "login.error": "Invalid credentials.",
  },
};

const LanguageContext = createContext(null);

// Pilot-vlag: verbergt de EN-taalwissel en houdt de app in het Nederlands.
// Zet op false om volledige NL/EN-ondersteuning ná de pilot weer aan te zetten.
const PILOT_LANG_LOCK = true;

export const LanguageProvider = ({ children }) => {
  // Pilot: EN-taalwissel tijdelijk uit (dekking ~5-10%, backend NL). Forceer NL.
  // Zet PILOT_LANG_LOCK op false om volledige tweetaligheid ná de pilot te heractiveren.
  const [lang, setLangState] = useState(() => (PILOT_LANG_LOCK ? "nl" : (localStorage.getItem("zk_lang") || "nl")));

  useEffect(() => { document.documentElement.lang = lang; }, [lang]);

  const setLang = useCallback((l) => {
    if (PILOT_LANG_LOCK) { localStorage.setItem("zk_lang", "nl"); setLangState("nl"); return; }
    const v = l === "en" ? "en" : "nl";
    localStorage.setItem("zk_lang", v);
    setLangState(v);
  }, []);

  const t = useCallback((key) => (STRINGS[lang] && STRINGS[lang][key]) || STRINGS.nl[key] || key, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) return { lang: "nl", setLang: () => {}, t: (k) => STRINGS.nl[k] || k };
  return ctx;
};

export const LanguageToggle = ({ className = "" }) => {
  const { lang, setLang } = useLang();
  if (PILOT_LANG_LOCK) return null;
  return (
    <div data-testid="language-toggle" className={`inline-flex items-center rounded-full border border-slate-200 bg-white overflow-hidden text-xs font-semibold ${className}`}>
      {["nl", "en"].map((l) => (
        <button key={l} data-testid={`lang-${l}`} onClick={() => setLang(l)}
          className={`px-2.5 py-1 transition-colors ${lang === l ? "bg-slate-900 text-white" : "text-slate-500 hover:text-slate-900"}`}>
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
};
